import angular from 'angular';
import uiRouter from 'angular-ui-router';

import './mysolvr-entries.scss';
import editBugModalComponent from 'edit-bug-modal';
import editHowToModalComponent from 'edit-how-to-modal';
import editNetworkpediaArticleModalComponent from 'edit-networkpedia-article-modal';
import editQuickTipModalComponent from 'edit-quick-tip-modal';
import editSolutionModalComponent from 'edit-solution-modal';
import mysolvrEntryDetailModule from './screens/mysolvr-entry-detail';
import mysolvrEntryListModule from './screens/mysolvr-entry-list';
import handleEntryEditFactory from 'handle-entry-edit.factory';
import mysolvrEntryFactory from 'mysolvr-entry.factory';

let mysolvrEntriesModule = angular.module('mysolvr-entries', [
  uiRouter,
  mysolvrEntryDetailModule.name,
  mysolvrEntryListModule.name,
])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $stateProvider
      .state('engineer.mysolvr-entries', {
        url: '/mysolvr',
        abstract: true,
        template: '<mysolvr-entries ui-view class="mysolvr-entries"></mysolvr-entries>',
      });
  })
  .component('editBugModal', editBugModalComponent)
  .component('editHowToModal', editHowToModalComponent)
  .component('editNetworkpediaArticleModal', editNetworkpediaArticleModalComponent)
  .component('editQuickTipModal', editQuickTipModalComponent)
  .component('editSolutionModal', editSolutionModalComponent)
  .factory('handleEntryEdit', handleEntryEditFactory)
  .factory('MysolvrEntry', mysolvrEntryFactory)
  .component('mysolvr-entries', {});

export default mysolvrEntriesModule;



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/mysolvr-entries/index.js